import { useWorkspaceId } from '@/shared/hooks/use-workspace-id';
import { useCallback } from 'react';

export const usePostNavigation = () => {
  const { workspaceId } = useWorkspaceId();

  const toPostPage = useCallback(
    (postId: string) => {
      window.open(
        `${window.location.origin}/workspace/${workspaceId}/post/${postId}`,
        '_blank',
        'noopener,noreferrer',
      );
    },
    [workspaceId],
  );

  return toPostPage;
};
